import {
  Icon,
  Button,
  SimpleGrid,
  useColorModeValue as mode,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverHeader,
  PopoverBody,
  PopoverFooter,
  PopoverArrow,
  PopoverCloseButton,
  ButtonGroup,
  useDisclosure
} from "@chakra-ui/react";
import { LuEdit3, LuSettings2, LuBrush, LuEye, LuRotateCcw } from "react-icons/lu";


const tabs = [
  {
    icon: LuEdit3,
    label: "Content",
  },
  {
    icon: LuSettings2,
    label: "Settings",
  },
  {
    icon: LuBrush,
    label: "Theme",
  },
];

const ResetButton = ({ onReset, buttonStyle }) => {
  const { isOpen, onToggle, onClose } = useDisclosure();
  return (
    <Popover isOpen={isOpen} onClose={onClose} placement="bottom">
      <PopoverTrigger>
        <Button
          onClick={onToggle}
          leftIcon={<Icon as={LuRotateCcw} />}
          {...buttonStyle}
        >
          Reset
        </Button>
      </PopoverTrigger>
      <PopoverContent bg={mode("neutral.lightMode.neutral", "neutral.darkMode.neutral")}>
        <PopoverHeader fontWeight="semibold">Confirmation</PopoverHeader>
        <PopoverArrow bg={mode("neutral.lightMode.neutral", "neutral.darkMode.neutral")} />
        <PopoverCloseButton />
        <PopoverBody>
          Are you sure you want to start a new carousel? This one will be deleted.
        </PopoverBody>
        <PopoverFooter display="flex" justifyContent="flex-end">
          <ButtonGroup size="sm">
            <Button variant="outline" onClick={onClose}>
              Cancel
            </Button>
            <Button
              colorScheme="red"
              onClick={() => { onReset(); onClose(); }}
            >
              Reset
            </Button>
          </ButtonGroup>
        </PopoverFooter>
      </PopoverContent>
    </Popover>
  );
}

export default function Tabs({
  activeTab,
  onChange,
  onReset,
  setIsPreviewMode,
}: {
  activeTab: string;
  onChange: (index: string) => void;
  onReset: () => void;
  setIsPreviewMode: (isPreviewMode: boolean) => void;
}) {
  const buttonStyle = {
    justifyContent: "center",
    fontSize: "0.75rem",
    color: mode("text.lightMode.light", "text.darkMode.light"),
    bg: "transparent",
    _hover: {
      bg: mode("primary.lightMode.100", "primary.darkMode.100"),
      color: mode("text.lightMode.standard", "text.darkMode.standard"),
    },
  };
  return (
    <SimpleGrid gap={"0.25rem"} columns={[3, tabs.length + 2]}>
      {tabs.map((tab) => (
        <Button
          key={tab.label}
          leftIcon={
            <Icon
              color={mode(
                activeTab === tab.label
                  ? "primary.lightMode.default"
                  : undefined,
                activeTab === tab.label ? "primary.lightMode.200" : undefined
              )}
              as={tab.icon}
            />
          }
          {...buttonStyle}
          _active={{
            bg: mode("primary.lightMode.100", "primary.darkMode.100"),
            color: mode("text.lightMode.standard", "text.darkMode.standard"),
          }}
          isActive={activeTab === tab.label}
          onClick={() => onChange(tab.label)}
        >
          {tab.label}
        </Button>
      ))}

      <Button
        leftIcon={<Icon as={LuEye} />}
        {...buttonStyle}
        onClick={() => setIsPreviewMode(true)}
      >
        Preview
      </Button>
      <ResetButton onReset={onReset} buttonStyle={buttonStyle} />

    </SimpleGrid>
  );
}
